import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { UtilService } from 'src/app/services/util.service';
import { Order, OrderGroup } from 'src/app/models/order.model';
import { AlertController } from '@ionic/angular';
import { IonContent } from '@ionic/angular';
import { PushService, TOPIC_RESTAURANT_IS_OPENING, TOPIC_ORDER } from 'src/app/services/push.service';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { Observable } from 'rxjs';
import { AlertService } from '../../../services/alert.service';
import { Router } from '@angular/router';
import { RestaurantService } from 'src/app/services/restaurant.service';
import { formatDate } from '@angular/common';
import { resolve } from 'q';
import { Events } from 'src/app/services/events.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.page.html',
  styleUrls: ['./order.page.scss'],
})
export class OrderPage implements OnInit {

  //@ViewChild('scrollMe', {static: false}) private myScrollContainer: ElementRef;
  @ViewChild(IonContent, { static: false }) content: IonContent;
  now: number = new Date().getTime();
  audio: any;

  constructor(public db: DBService, public util: UtilService, private router: Router, private ngZone: NgZone, private pushService: PushService, private alertCtrl: AlertController,
    private insomnia: Insomnia, private alert: AlertService, public restaurantService: RestaurantService, private events: Events) {

  }

  initAudio(){
    this.audio = new Audio();
    this.audio.src = 'https://barela.de/assets/sounds/order.mp3';
    this.audio.volume = 1
    this.audio.load();

    this.events.unsubscribe('newOrder')
    this.events.subscribe('newOrder', () => {
      if(this.db.currentRestaurant.options && this.db.currentRestaurant.options.soundForNewOrder)
        this.audio.play();
      //this.audio.pause
      //this.audio.loop = true;
    });
  }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }

    this.initAudio();
    this.now = new Date().getTime();
    this.util.changeOrderUi('current')

    //display must keep awake in order ui
    this.insomnia.keepAwake()
      .then(() => console.log('success'),
      (e) => console.log('error', e));
  }

  get myPrivateOrders(): OrderGroup[] {
    let myOrders = []
    if (!this.db.myPrivateOrders || this.db.myPrivateOrders.length <= 0) return myOrders
    for (let orderGroup of this.db.myPrivateOrders) {                                                         //weiss noch nciht
      if (!orderGroup.isService && orderGroup.restaurantKey === this.db.currentRestaurantKey && this.now < (orderGroup.timestamp + (1000 * 60 * 60 * 24 * 14) )) {
     // if (!orderGroup.isService && orderGroup.restaurantKey === this.db.currentRestaurantKey && this.now < (orderGroup.requiredTimeInMinutes * 60 * 1000 + orderGroup.timestamp + (1000 * 60 * 60 * 24 * 14) )) {
        myOrders.push(orderGroup)
      }
    }

    return myOrders
  }

  changeOrderUi(orderUi: string) {
    this.util.changeOrderUi(orderUi)
    setTimeout(() => {
      this.scrollToBottom();
      this.db.orderChanged = false; //todo muss auch true sein, wenn etwas abgehackt ist, ...
    }, 300);
  }


  onBatteryStatus: any
  clickHandler: any

  ngAfterViewInit() {
    this.scrollToBottom();

    //******************************************** */
    this.onBatteryStatus = function (status: any) {
      this.ngZone.run(() => this.util.batteryLevel = status.level)
    }
    // save the click handler so it can be used in multiple places
    this.clickHandler = this.onBatteryStatus.bind(this);
    window.addEventListener('batterystatus', this.clickHandler)
    //******************************************** */
  }

  ngOnDestroy() {
    console.log("ngOnDestroy")
    window.removeEventListener('batterystatus', this.clickHandler)

    if(this.audio) {
      this.audio.pause();
      this.audio = null;
    }
  }



  /*
    logScrollStart(){
      this.util.log("logScrollStart")
    }
  */
  logScrolling(event) {
    this.util.log("logScrolling", event)

    if (!(this.db.isOwner || this.db.isEmployee)) return

    if (event && event.detail && event.detail.velocityY) {
      //  console.error(event.detail.velocityY)
    }
    if (this.util.orderUi === 'current' && event && event.detail && event.detail.velocityY && (event.detail.velocityY > 0.8 || event.detail.velocityY < -0.8)) {
      if ((this.lastTimeChangedDoneField + 500) < new Date().getTime())
        this.autoScrollEnabled = false;
    }
  }
  /*
    logScrollEnd(){
      this.util.log("logScrollEnd")
    }
  */
  back() {
    // this.db.setPage('home')

    //Wenn gar nicht ausgeloest ist, dann raus
    if (!this.db.loggedUserUID || !(this.db.isOwner || this.db.isEmployee)) this.ngZone.run(() => this.router.navigate(['/customer-home']))
    else this.ngZone.run(() => this.router.navigate(['/owner-home']))
  }

  openBasket() {
    this.ngZone.run(() => this.router.navigate(['/basket']))
  }

  //*** SCROLL START ***/
  autoScrollEnabled: boolean = true;

  ngAfterViewChecked() {
    this.util.log("ngAfterViewChecked")
    if (this.db.orderChanged && this.util.orderUi === 'current') {
      setTimeout(() => {
        this.scrollToBottom();
        this.db.orderChanged = false; //todo muss auch true sein, wenn etwas abgehackt ist, ... => glaube erledigt
      }, 100); //TODO war 500
    }

    //update delivery time...
    if (new Date().getTime() % 5000 > 4500) {
      this.ngZone.run(() => console.log("force ui update"))
      this.now = new Date().getTime()

      if(!this.audio) this.initAudio()
    }
  }

  showLast48h: boolean = true;
  //172800000 = 2 days//Zeige nur Eintraege der letzten 2 Tage, ausser es sollen alle gezeigt werden...
  filterItems(currentOrderGroupKeys: string[]): string[] {

    //TODO: auch requiredTimeInMinutes berücksichtigen
    if (this.util.orderUi === 'current') {
      currentOrderGroupKeys = currentOrderGroupKeys.filter(groupKey => {
        return this.isInFilter(this.db.currentOrderGroups[groupKey]) && this.orderGroupIsNotComplete(this.db.currentOrderGroups[groupKey]); //Bei den offenen, sollen immer alle angezeigt werden
      });
    } else {
      currentOrderGroupKeys = currentOrderGroupKeys.filter(groupKey => {
        return (!this.showLast48h || (this.now < (this.db.currentOrderGroups[groupKey].timestamp + 172800000))) && this.isInFilter(this.db.currentOrderGroups[groupKey]) && !this.orderGroupIsNotComplete(this.db.currentOrderGroups[groupKey]);
      });
    }

    return currentOrderGroupKeys.sort((a, b) => {
      return (this.db.currentOrderGroups[a].timestamp + this.db.currentOrderGroups[a].requiredTimeInMinutes * 1000 * 60) - (this.db.currentOrderGroups[b].timestamp + this.db.currentOrderGroups[b].requiredTimeInMinutes * 1000 * 60)
    });

  }

  showInfoAlert(orderGroup: OrderGroup) {
    this.confirmOrder(orderGroup)

    let paid: string = ", Bereits bezahlt: Nein";
    if (orderGroup.paid) paid = ", Bereits bezahlt: Ja"
    if (orderGroup.mode == 'take-away') {
      this.util.a.presentAlertInfo('Telefon: ' + orderGroup.phone + ', Bringt Box mit: ' + (orderGroup.bringBox ? 'Ja' : 'Nein') + paid)
    } else if (orderGroup.mode == 'delivery' && !orderGroup.paid) {
      this.util.a.presentAlertInfo('Telefon: ' + orderGroup.phone + ', Zahlt mit EC-Karte: ' + (orderGroup.ecCard ? 'Ja' : 'Nein') + paid)
    } else if (orderGroup.mode == 'delivery' && orderGroup.paid) {
      this.util.a.presentAlertInfo('Telefon: ' + orderGroup.phone + paid)
    }
  }

  currentFilter: string[] = ["eat-here", "take-away", "delivery", "in48h"]
  filter() {
    let cbEatHere = this.alert.createCheckInput("Hier Essen", "Hier Essen", "eat-here", this.currentFilter, this.currentFilter.includes("eat-here"), this.db.currentRestaurant.orderMode["eat-here"] == true, "checkbox")
    let cbTakeAway = this.alert.createCheckInput("Zum Abholen", "Zum Abholen", "take-away", this.currentFilter, this.currentFilter.includes("take-away"), this.db.currentRestaurant.orderMode["take-away"] == true, "checkbox")
    let cbDelivery = this.alert.createCheckInput("Zum Liefern", "Zum Liefern", "delivery", this.currentFilter, this.currentFilter.includes("delivery"), this.db.currentRestaurant.orderMode["delivery"] == true, "checkbox")
    let cbLast48H = this.alert.createCheckInput("Innerhalb 48h", "Innerhalb 48h", "in48h", this.currentFilter, this.currentFilter.includes("in48h"), true, "checkbox")

    let options: any[] = [cbEatHere, cbTakeAway, cbDelivery]
    if (this.util.orderUi === 'done') options.push(cbLast48H)

    this.alert.presentAlertCheck(this, (ref, data) => {
      console.log(data)
      if (data) this.currentFilter = data
      if (data && this.util.orderUi === 'done') {
        this.showLast48h = this.currentFilter.includes("in48h")
        this.showLast48HChanged();
      }
      ref.ngZone.run(() => console.log("force ui update"))
    }, options, "Filtere deine Bestellungen", undefined)
  }

  showLast48HChanged() {
    if (!this.showLast48h) {
      this.util.presentToast('Alle Bestellungen werden angezeigt')
    } else {
      this.util.presentToast('Bestellungen der letzten 48h werden angezeigt')
    }
  }

  scrollToBottom(): void {
    this.util.log("scrollToBottom")
    if (!this.autoScrollEnabled && this.util.orderUi === 'current') { //nur wenn autoscroll enabled ist
      return
    }

    try {
      // this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
      if (this.content) this.content.scrollToBottom();
    } catch (err) { this.util.error(err) }
  }

  setAutoScrollEnabled(value: boolean) {
    this.autoScrollEnabled = value;
    this.scrollToBottom();
    this.db.newOrder = false
  }
  //*** SCROLL ENDE ***/

  /*
  getOrderKeys(): string[] {
    return Object.keys(this.db.currentOrderGroups)
  }
*/

  isInFilter(orderGroup: OrderGroup) {
    return this.currentFilter.includes(orderGroup.mode)
  }

  orderGroupIsNotComplete(orderGroup: OrderGroup): boolean {
    for (let order of orderGroup.order) {
      if (order.state == 0 && orderGroup.isService) {
        return true; //Service ohne amount berechnen
      }

      if (order.state == 0 && order.amount && order.amount > 0) {
        return true;
      }
    }

    return false;
  }

  orderGroupHasStarted(orderGroup: OrderGroup): boolean {
    for (let order of orderGroup.order) {
      if (order.state != 0 && order.amount && order.amount > 0) {
        return true;
      }
    }

    return false;
  }

  changeTime(orderGroup: OrderGroup) {
    this.confirmOrder(orderGroup)
    if (this.util.orderUi != 'current') return

    let inputs = []
    let date = formatDate(new Date(orderGroup.timestamp + (orderGroup.requiredTimeInMinutes * 1000 * 60)), 'yyyy-MM-dd', 'de-DE')
    let time = formatDate(new Date(this.util.roundTime5Minutes(orderGroup.timestamp + (orderGroup.requiredTimeInMinutes * 1000 * 60))), 'HH:mm', 'de-DE')

    inputs.push({ name: 'date', type: 'date', id: 'date', value: date, placeholder: `z.B. ${date}` })
    inputs.push({ name: 'time', type: 'time', id: 'time', value: time, placeholder: `z.B. ${time}` })
    this.alert.presentMultipleAlertPrompt(this, (ref, data) => {
      let time = data.date + " " + data.time + ":00"
      let newDate = new Date(new Date(time).getTime() + 31000) //+31000 wegen kleiner Fehler beim Runden
      orderGroup.requiredTimeInMinutes = Math.round((newDate.getTime() - orderGroup.timestamp) / 1000 / 60)
      ref.db.updateOrderGroup(orderGroup)
      if (ref.orderGroupIsNotComplete(orderGroup)) {
        ref.util.presentToast("Zubereitungszeit festgelegt - der Kunde wurde per Push benachrichtigt.")
        let deliveryDate = new Date(orderGroup.timestamp + orderGroup.requiredTimeInMinutes * 1000 * 60) 
        ref.pushService.sendPushToCustomer(orderGroup, "Ungefähre Zubereitungszeit: " + formatDate(deliveryDate, 'dd.MM.yyyy HH:mm', 'de-DE') + " Uhr", "Der ungefähre Zeitpunkt für die Zubereitung deiner Bestellung ist: " + formatDate(deliveryDate, 'dd.MM.yyyy HH:mm', 'de-DE') +" Uhr.", TOPIC_ORDER + "-" + orderGroup.id, "testtag").subscribe((val: any) => { })
      }
      ref.ngZone.run(() => console.log("force ui update"))
    }, inputs, 'Zuberetungszeit festlegen', 'Bitte gib ein Datum und eine Uhrzeit an, wann die Bestellung fertig ist.', "")
  }


  confirmOrder(orderGroup: OrderGroup, dbInteraction: boolean = true) {
    if (!orderGroup) return

    //User Interaktion => Bestellung wird bearbeitet
    if (!orderGroup.confirmed) {
      orderGroup.confirmed = true
      if (this.orderGroupIsNotComplete(orderGroup)) {
        this.pushService.sendPushToCustomer(orderGroup, "Neue Nachricht von " + this.db.currentRestaurant.name, "Deine Bestellung ist aufgenommen und bestätigt.", TOPIC_ORDER + "-" + orderGroup.id, "testtag").subscribe((val: any) => { })
        this.util.presentToast("Status-Änderungen gespeichert und Kunde informiert")
      }
    }
    if(dbInteraction) this.db.updateOrderGroup(orderGroup)
  }

  lastTimeChangedDoneField: number = -1;
  async changeDoneField(order: Order, orderGroup: OrderGroup) {
    this.confirmOrder(orderGroup, false)
    if (order.state == 0) {
      order.state = 2
      if (!this.orderGroupIsNotComplete(orderGroup) && !orderGroup.isService) {
        // *** disbaled due to too many mails ***
        // this.pushService.sendPushToCustomer(orderGroup, "Bestellung bearbeitet", "Deine Bestellung bei " + this.db.currentRestaurant.name + " wurde bearbeitet.", TOPIC_ORDER + "-" + orderGroup.id, "testtag").subscribe((val: any) => { })
      }
      /* for admin sake 
      for (let groupKey of this.filterItems(this.db.currentOrderGroupKeys)) {
        for (let orderr of this.db.currentOrderGroups[groupKey].order) {
          orderr.state = 2
        }
        this.db.updateOrderGroup(this.db.currentOrderGroups[groupKey])
      }*/


    }
    else order.state = 0
    this.lastTimeChangedDoneField = new Date().getTime();

    this.updateAsync(orderGroup)

    //this.db.orderChanged = true;

    //Alle Services schliessen
    if (!orderGroup.isService || order.state != 2) return

    for (let orderGroupAllKey of Object.keys(this.db.currentOrderGroupsAll)) {
      //TODO nach Restarant abfragen? eigentlich nicht, weil immer bei select restaurant neu geladen wird
      if (this.db.currentOrderGroupsAll[orderGroupAllKey].isService && this.db.currentOrderGroupsAll[orderGroupAllKey].source === orderGroup.source && this.db.currentOrderGroupsAll[orderGroupAllKey].order.length === 1 && this.db.currentOrderGroupsAll[orderGroupAllKey].order[0].fixedItemName === order.fixedItemName) {
        this.db.currentOrderGroupsAll[orderGroupAllKey].order[0].state = 2;
        this.db.updateOrderGroup(this.db.currentOrderGroupsAll[orderGroupAllKey])

        //Alle anderen Services gleichzeitig schliessen
        for (let orderGroupKey of Object.keys(this.db.currentOrderGroups)) {
          if (this.db.currentOrderGroups[orderGroupKey].isService && this.db.currentOrderGroups[orderGroupKey].source === orderGroup.source && this.db.currentOrderGroups[orderGroupKey].order.length === 1 && this.db.currentOrderGroups[orderGroupKey].order[0].fixedItemName === order.fixedItemName) {
            this.db.currentOrderGroups[orderGroupKey].order[0].state = 2;

            this.db.updateOrderGroup(this.db.currentOrderGroups[orderGroupKey])
          }
        }
      }
    }
  }

  // *** update async since no ui update problems ***
  updateAsync(orderGroup) {
    return new Promise(resolve => {
      setTimeout(() => {
        this.db.updateOrderGroup(orderGroup)
        resolve('resolved');
      }, 1500);
    });
  }


  async ask2OpenGetippt(orderGroup: OrderGroup) {
    if (!orderGroup.getippt) {
      orderGroup.getippt = true;
      this.db.updateOrderGroup(orderGroup)
    } else {
      this.alert.presentAlertConfirm(this, (ref) => {
        orderGroup.getippt = false;
        ref.db.updateOrderGroup(orderGroup)
      }, 'Bestellung wieder öffnen?', 'Sicher, dass du diese Bestellung nicht bereits in die Kasse getippt hast?')
    }
  }

  async ask2OpenPaid(orderGroup: OrderGroup) {
    if (orderGroup.paid) {
      orderGroup.paid = false;
      this.db.updateOrderGroup(orderGroup)
    } else {
      this.alert.presentAlertConfirm(this, (ref) => {
        orderGroup.paid = true;
        ref.db.updateOrderGroup(orderGroup)
      }, 'Bestellung bezahlt?', 'Bitte bestätige, dass diese Bestellung bezahlt wurde.')
    }
  }

  showItemPrice(order: Order) {
    if (!order) return
    if (order.bonuscardPrice > -1) {
      this.util.a.presentAlertInfo('Bonuskarte: ' + this.util.formatPrice(order.bonuscardPrice) + ' €')
      return
    }
    this.util.a.presentAlertInfo('Preis: ' + this.util.formatPrice(order.fixedPrice) + ' €, Extras: ' + this.util.formatPrice(order.extraPrice) + ' €, Optionen: ' + this.util.formatPrice(order.optionPrice) + ' €, Anzahl: ' + order.amount)
  }

  async changeOrder(orderGroup: OrderGroup, order: Order) {
    console.log(order)
    if (this.util.orderUi !== 'current') {
      //   return    //changing amount is also possible after it was done
    }

    let inputs = []

    inputs.push(
      {
        name: 'radio0',
        type: 'radio',
        label: '0 (Stornierung)',
        value: '0',
        checked: (order.amount === 0)
      }
    )

    for (let i = 1; i <= 10; i++) {
      inputs.push(
        {
          name: 'radio' + i,
          type: 'radio',
          label: i,
          value: i + '',
          checked: (order.amount === i)
        }
      )
    }

    inputs.push(
      {
        name: 'radio99',
        type: 'radio',
        label: 'mehr...',
        value: '99',
        checked: (order.amount > 10)
      }
    )

    const alert = await this.alertCtrl.create({
      header: 'Ändere die Bestellung',
      cssClass: 'myAlert',
      inputs: inputs,
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          cssClass: 'alert-button',
          handler: () => {
            this.util.log('Confirm Cancel');
          }
        }, {
          text: 'Speichern',
          cssClass: 'alert-button',
          handler: (data) => {
            if (data && +data < 99) {
              order.amount = +data
              if (order.amount <= 0) {
                order.amount = 0;
                order.state = 2
                this.pushService.sendPushToCustomer(orderGroup, "Bestellung abgelehnt", "Leider wurde mindestens ein Teil deiner Bestellung vom Restaurant storniert. Du kannst gerne das Restaurant anrufen falls du mehr Informationen benötigst.", TOPIC_ORDER + "-" + orderGroup.id, "testtag").subscribe((val: any) => { })
              }

              this.save(orderGroup)
            } else if (+data === 99) {
              this.changeOrderMoreThan10(orderGroup, order)
            }
          }
        }
      ]
    });

    await alert.present();
  }

  async changeOrderMoreThan10(orderGroup: OrderGroup, order: Order) {
    const alert = await this.alertCtrl.create({
      header: 'Ändere die Bestellung',
      cssClass: 'myAlert',
      inputs: [
        {
          name: 'amount',
          type: 'number',
          value: order.amount
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          cssClass: 'alert-button',
          handler: () => {
            this.util.log('Confirm Cancel');
          }
        }, {
          text: 'Speichern',
          cssClass: 'alert-button',
          handler: (data) => {
            if (data.amount) {
              order.amount = +data.amount
              if (order.amount <= 0) {
                order.amount = 0;
                order.state = 2
              }
              this.save(orderGroup)
            }
          }
        }
      ]
    });
    await alert.present();
  }

  sortedOrder(orderGroup: OrderGroup): Order[]{
    try{
      return orderGroup.order.sort(function(a, b) {
        if (a.fixedCatName < b.fixedCatName) {
          return -1;
        }
        if (a.fixedCatName > b.fixedCatName) {
          return 1;
        }
      
        if (a.fixedItemName < b.fixedItemName) {
          return -1;
        }
        if (a.fixedItemName > b.fixedItemName) {
          return 1;
        }
        // Namen müssen gleich sein
        return 0;
      });
    } catch (e) {
      return orderGroup.order
    }
  }

  async sendNotification(orderGroup: OrderGroup) {
    this.alert.presentAlertPrompt(null, (ref, data) => {
      if (data.input) {
        orderGroup.noteFromRestaurant = data.input
        this.pushService.sendPushToCustomer(orderGroup, "Neue Nachricht von " + this.db.currentRestaurant.name, data.input, TOPIC_ORDER + "-" + orderGroup.id, "testtag").subscribe((val: any) => { })
        this.util.presentToast("Die Nachricht wurde dem Kunden zugestellt.")
        this.save(orderGroup)
      }
    }, "Push-Benachrichtigung an den Kunden", "", "", "Deine Nachricht an den Kunden...", "Abbrechen", "Senden")
  }

  status(orderGroup: OrderGroup): string {
    if (this.orderGroupIsNotComplete(orderGroup)) {
      if (orderGroup.confirmed) return "Aufgenommen & Bestätigt";
      else return "Noch nicht bestätigt";
    } else {
      return "Zubereitet"
    }
  }


  async openState(orderGroup: OrderGroup) {
    let orgConfirmed: boolean = orderGroup.confirmed
    let orgPaid: boolean = orderGroup.paid
    let orgGetippt: boolean = orderGroup.getippt
    let cbConfirmed = this.alert.createCheckInput("Gesehen", "Gesehen", "confirmed", orderGroup.confirmed, orderGroup.confirmed == true, true, "checkbox")
    let cbPaid = this.alert.createCheckInput("Bezahlt", "Bezahlt", "paid", orderGroup.paid, orderGroup.paid == true, true, "checkbox")
    let cbGetippt = this.alert.createCheckInput("Getippt", "Getippt", "getippt", orderGroup.getippt, orderGroup.getippt == true, true, "checkbox")

    let options: any[] = [cbConfirmed, cbPaid, cbGetippt]

    this.alert.presentAlertCheck(this, (ref, data) => {
      console.log(data)
      if (data) {
        orderGroup.confirmed = data.includes("confirmed")
        orderGroup.paid = data.includes("paid")
        orderGroup.getippt = data.includes("getippt")

        //nochmal Abfrage, ob es wirklich korrekt ist, dass der Kunde bezahlt hat...
        if (!orgPaid && orderGroup.paid) {
          let tmpConfirmed: boolean = orderGroup.confirmed
          let tmpPaid: boolean = orderGroup.paid
          let tmpGetippt: boolean = orderGroup.getippt
          orderGroup.confirmed = orgConfirmed
          orderGroup.paid = orgPaid
          orderGroup.getippt = orgGetippt
          this.alert.presentAlertConfirm(this, (ref) => {
            orderGroup.confirmed = tmpConfirmed
            orderGroup.paid = tmpPaid
            orderGroup.getippt = tmpGetippt
            ref.save(orderGroup)

            if (!orgConfirmed && orderGroup.confirmed && ref.orderGroupIsNotComplete(orderGroup)) {
              // *** diabled since too many mails ***
              // ref.pushService.sendPushToCustomer(orderGroup, "Neue Nachricht von " + ref.db.currentRestaurant.name, "Deine Bestellung befindet sich nun in Zubereitung.", TOPIC_ORDER + "-" + orderGroup.id, "testtag").subscribe((val: any) => { })
              ref.util.presentToast("Status-Änderungen gespeichert und Kunde informiert")
            } else {
              ref.util.presentToast("Status-Änderungen gespeichert")
            }
          }, 'Bestellung bezahlt?', 'Bitte bestätige, dass diese Bestellung bezahlt wurde.')
        } else {
          this.save(orderGroup)

          if (!orgConfirmed && orderGroup.confirmed && this.orderGroupIsNotComplete(orderGroup)) {
            // *** diabled since too many mails ***
            // this.pushService.sendPushToCustomer(orderGroup, "Neue Nachricht von " + this.db.currentRestaurant.name, "Deine Bestellung befindet sich nun in Zubereitung.", TOPIC_ORDER + "-" + orderGroup.id, "testtag").subscribe((val: any) => { })
            this.util.presentToast("Status-Änderungen gespeichert und Kunde informiert")
          } else {
            this.util.presentToast("Status-Änderungen gespeichert")
          }
        }
      }
      ref.ngZone.run(() => console.log("force ui update"))
    }, options, "Status dieser Bestellung", undefined)
  }

  save(orderGroup: OrderGroup) {
    this.db.orderGroupRef(orderGroup.restaurantKey).update(orderGroup.id, orderGroup)
  }


}
